var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'on':_vm.isShow},attrs:{"id":"HomeHeaderFixed"}},[_c('PublicHeader',{ref:"PublicHeader",attrs:{"is-show-search":true,"nav-type":_vm.COMMON.HEADER.NAV.TYPE.OTHER,"isFixedHeader":true},on:{"topTop":_vm.topTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }